<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
    const dataList = [
  {
    name: "交易总额",
    value: [39.43, 41.64, 43.7],
  },
  {
    name: "企业",
    value: [341, 374, 413],
  },
  {
    name: "人数",
    value: [962, 1078, 1210],
  },
]; // 数据列表
    const yData1 = [394.3, 416.4, 437.0]
    const yData2 = [341, 374, 413]
    const yData3 = [962, 1078, 1210]
    this.state.chart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
    },
    legend: {
        show:true,
        itemWidth: 40,
        itemHeight: 20,
        top: '2%',
        left: 'center',
        icon: 'rect',
        textStyle: {
        color: "#fff",
        fontSize: 28,
        lineHeight: 28,
    },
    },
    grid: {
      show:false,
        bottom: '8%',
        left: '10%',
        right: '4%',
        containLabel: true
    },
    xAxis: {
        data: ['2023年', '2024年', '2025年'],
        axisTick: {
        show: false
        },
        axisLabel: {
          interval: 0,
          rotate: 0,
          fontSize: 26,
          color:"#fff"
        }
    },
    yAxis: {
        name:"",
        type: 'value',
        nameTextStyle: {
            align: 'left', // 对齐方式
            verticalAlign: 'top' ,// 垂直对齐方式
            color:"rgba(255,255,255,.8)",
            fontSize: 24,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255,255,255,.2)',
            width: 1,
            type: 'solid'
          }
        },
        axisLabel: {
          show:false,
          fontSize: 24,
          color:"rgba(255,255,255,.8)"
        },
    },
    series:[
      {
        name: '交易总额',
        type: 'bar',
        barWidth: '14%',
        itemStyle: {
          color:new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                  offset: 0,
                  color:"#2AE604"
              },
              {
                  offset: 1,
                  color:"#112534"
              }
            ])
        },
        label: {
          normal: {
            show: true,
            position: 'top',
            fontSize: 24,
            color:"#fff",
            formatter: function(params) {
                return (params.value / 10).toFixed(2); // 乘以 100，保留两位小数
            }
          }
        },
        data: yData1
      },
      {
        name: "企业",
        type: 'bar',
        barWidth: '14%',
        itemStyle: {
          color:new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                  offset: 0,
                  color:"#810BE3"
              },
              {
                  offset: 1,
                  color:"#112534"
              }
            ])
        },
        label: {
          normal: {
            show: true,
            position: 'top',
            fontSize: 24,
            color:"#fff",
          }
        },
        data: yData2
      },
      {
        name: '人数',
        type: 'bar',
        barWidth: '14%',
        barGap:"0.6",
        itemStyle: {
          color:new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                  offset: 0,
                  color:"#01EDF7"
              },
              {
                  offset: 1,
                  color:"#0D2C3C"
              }
            ])
        },
        label: {
          normal: {
            show: true,
            position: 'top',
            fontSize: 24,
            color:"#fff",
          }
        },
        data: yData3
      },
    ] 
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
